<template>
  <div>
    <Tree :filter="true" :loading="loading"
          :selectionKeys.sync="fieldValue" :value="options"
          filterMode="strict"
          selectionMode="checkbox"></Tree>
  </div>
</template>

<script>
import SearchFieldService from "../services/searchfield.service";

const FIELD_NAME = "LICENCE_TERRITORIES";
export default {
  name: "TerritoryTree",
  props: ['value'],
  data() {
    return {
      fieldValue: null,
      options: [],
      loading: false
    }
  },
  methods: {
    load() {
      this.loading = true;
      SearchFieldService.loadLookupData(FIELD_NAME).then(r => {
        this.options = r.data;
        this.loading = false;
      })
    },
  },
  watch: {
    fieldValue: function () {
      let checked = new Set();
      for (let s in this.fieldValue) {
        if (this.fieldValue[s].checked) {
          checked.add(s);
        }
      }
      this.$emit('input', checked);
      if (checked.size === 0) {
        let data = {
          selection: [],
          displayText: 'no filter'
        }
        this.$emit('selectionApplied', data)
      } else {
        let arr = Array.from(checked);
        SearchFieldService.loadTerritoryDisplayText(arr).then(r => {
          let data = {
            selection: arr,
            displayText: r.data.shortText
          }
          this.$emit('selectionApplied', data)
        })
      }
    }
  },
  mounted() {
    this.load();
  }
}
</script>

<style scoped>

</style>